import React, { useEffect, useState } from "react";
import { SnackbarPopQuizProps } from "../interface/Success_SnackBar_Interface";
import "../styles/successInfoStyle.css";
import snackTickImg from "../assets/images/snack_tick.png";
import blueInfo from "../assets/images/popQuiz/exlamatoryImg.png";
import snackCloseImg from "../assets/images/snack_close.png";
const PopQuizUnAnsweredSnackBar: React.FC<SnackbarPopQuizProps> = ({
  message,
}) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  if (!visible) return null;

  return (
    <div
      className="info-snackbarContainer"
      style={{
        borderLeft: "8px solid #044472", // or any color you prefer
      }}
    >
      {/* Image and Text */}
      <div className="info-snackbarContent">
        <img src={blueInfo} alt="Success" className="info-icon" />
        <p className="info-text-bar">{message}</p>
      </div>

      {/* Close Icon */}
      <button
        onClick={() => {
          setVisible(false);
        }}
        className="closeButton"
      >
        <img src={snackCloseImg} alt="Close" className="info-closeIcon" />
      </button>
    </div>
  );
};

export default PopQuizUnAnsweredSnackBar;
